module.exports = __webpack_public_path__ + "static/media/JohnMcClane.0655f9d9.png";